export default __webpack_public_path__ + "static/media/ig_icon.4a8e5093.svg";